import PaymentTypeEnum from '@/api/Enums/PaymentTypeEnum'

export default {
  Title: 'Παραγγελίες | Παραγγελία | Παραγγελίες',

  Headers: {
    SourceType   : '',
    OrderId      : '#',
    Customer     : 'ΠΕΛΑΤΗΣ',
    User         : 'ΧΡΗΣΤΗΣ',
    Status       : 'ΚΑΤΑΣΤΑΣΗ',
    DailyCheck   : 'ΑΡ. ΗΜΕΡ.',
    OrderNumber  : 'ΑΡ. ΠΑΡΑΓ.',
    OrderType    : 'ΤΥΠΟΣ',
    PrintNotify  : 'ΕΚΤΥΠΩΣΗ',
    Payment      : 'ΠΛΗΡΩΜΗ',
    Total        : 'ΣΥΝΟΛΟ',
    Date         : 'ΗΜΕΡΟΜΗΝΙΑ',
    DateAdded    : 'ΚΑΤΑΧΩΡΗΣΗ',
    DateScheduled: 'ΠΡΟΓΡΑΜΜΑΤΙΣΜΟΣ',
    Transmission : 'ΔΙΑΒΙΒΑΣΗ'
  },

  ScheduledOrder: {
    Title  : 'Προγραμματισμός παραγγελίας',
    Default: {
      Title   : 'Τυπική',
      Subtitle: ''
    },
    Custom: {
      Title     : 'Προγραμματισμένη',
      Collection: 'Επιλέξτε χρόνο παραλαβής',
      Delivery  : 'Επιλέξτε χρόνο διανομής'
    }
  },

  Total: {
    PartiallyPaid: 'Μερικώς Πληρωμένο',
    GeneratingDoc: 'Εκδίδεται παραστατικό',
    NoFiscalDoc  : 'Χωρίς Παραστατικό',
    Receipt      : 'Απόδειξη',
    Invoice      : 'Τιμολόγιο'
  },

  Type: {
    Title: 'Τύπος Παραγγελίας',
    Item : {
      Delivery: {
        Id    : 1,
        Active: true,
        Title : 'Παράδοση',
        Icon  : 'directions_bike',
        Color : 'purple'
      },
      Collection: {
        Id    : 2,
        Active: true,
        Title : 'Παραλαβή',
        Icon  : 'directions_run',
        Color : 'blue darken-3'
      },
      SelfService: {
        Id    : 3,
        Active: true,
        Title : 'Self-Service',
        Icon  : 'mdi-gesture-double-tap',
        Color : 'teal'
      }
    },
    Time: {
      Day: {
        Title : 'Ημέρα | Ημέρες',
        Suffix: 'ημ'
      },
      Hour: {
        Title : 'Ώρα | Ώρες',
        Suffix: 'ώ'
      },
      Minute: {
        Title : 'Λεπτό | Λεπτά',
        Suffix: 'λ'
      },
      Second: {
        Title : 'Δευτερόλεπτο | Δευτερόλεπτα',
        Suffix: 'δ'
      }
    }
  },

  PaymentMethod: {
    Title: 'Μέθοδος πληρωμής | Μέθοδοι πληρωμών',
    Card : {
      Code : PaymentTypeEnum.CARD,
      Title: 'Κάρτα',
      Icon : 'credit_card',
      Color: 'blue-grey darken-2'
    },
    DeliveryCard: {
      Code : PaymentTypeEnum.DELIVERY,
      Title: 'Κάρτα Delivery',
      Icon : 'chrome_reader_mode',
      Color: 'blue darken-2'
    },
    Iris: {
      Code : 'iris',
      Title: 'IRIS',
      Icon : 'mdi-camera-iris',
      Image: 'iris.png',
      Color: 'green darken-3'
    },
    QrIris: {
      Code : PaymentTypeEnum.QR_IRIS,
      Title: 'QR IRIS',
      Icon : 'mdi-camera-iris',
      Image: 'iris.png',
      Color: 'green darken-3'
    },
    PosIris: {
      Code : PaymentTypeEnum.POS_IRIS,
      Title: 'POS IRIS',
      Icon : 'mdi-camera-iris',
      Image: 'iris.png',
      Color: 'green darken-3'
    },
    Cash: {
      Code : PaymentTypeEnum.CASH,
      Title: 'Μετρητά',
      Icon : 'euro_symbol',
      Color: 'amber darken-3'
    },
    SelfDelivery: {
      Code : PaymentTypeEnum.SELF_DELIVERY,
      Title: 'Αυτοπαράδοση',
      Icon : 'mdi-handshake',
      Color: 'cyan darken-2'
    },
    OnCredit: {
      Code : PaymentTypeEnum.ON_CREDIT,
      Title: 'Επι Πιστώσει',
      Icon : 'mdi-alpha-c-circle-outline',
      Color: 'indigo darken-3'
    },
    Check: {
      Code : PaymentTypeEnum.CHECK,
      Title: 'Επιταγή',
      Icon : 'mdi-checkbook',
      Color: 'teal darken-3'
    },
    WebBanking: {
      Code : PaymentTypeEnum.WEB_BANKING,
      Title: 'Τραπεζική Μεταφορά',
      Icon : 'mdi-bank-transfer',
      Color: 'brown darken-3'
    },
    Prepaid: {
      Code : PaymentTypeEnum.PREPAID,
      Title: 'Προπληρωμένη',
      Icon : 'mdi-credit-card-fast',
      Color: 'red darken-3'
    },
    Voucher: {
      Code : PaymentTypeEnum.VOUCHER,
      Title: 'Διατακτική',
      Icon : 'mdi-ticket-percent',
      Color: 'indigo darken-1'
    },
    TicketRestaurant: {
      Code : PaymentTypeEnum.TICKET_RESTAURANT,
      Title: 'Ticket Restaurant',
      Icon : 'mdi-ticket',
      Color: 'blue darken-3'
    }
  },

  FilterStatuses: {
    Title: 'Κατάσταση Παραγγελίας',
    Items: {
      Received: {
        Id      : 11,
        StatusId: 11,
        Title   : 'Ληφθείσα'
      },
      Accepted: {
        Id      : 21,
        StatusId: 21,
        Title   : 'Αποδεκτή'
      },
      Completed: {
        Id      : 15,
        StatusId: 15,
        Title   : 'Ολοκληρωμένη'
      },
      Canceled: {
        Id       : 19,
        StatusId : 19,
        DeletedAt: false,
        Title    : 'Ακυρωμένη'
      },
      Deleted: {
        Id       : -19,
        StatusId : 19,
        DeletedAt: true,
        Title    : 'Διαγραμμένη'
      }
    }
  },

  Statuses: {
    NotComplete: 'Εκκρεμής',
    Pending    : 'Εκκρεμής',
    Received   : 'Ληφθείσα',
    Preparation: 'Προετοιμάζεται',
    Delivery   : 'Παραδίδεται',
    Completed  : 'Ολοκληρωμένη',
    Canceled   : 'Ακυρωμένη',
    Deleted    : 'Διαγραμμένη',
    Printed    : 'Εκτυπωμένη',
    Accepted   : 'Αποδεκτή',

    Next: {
      Receive : 'Receive',
      Accept  : 'Αποδοχή',
      Prepare : 'Προετοιμασία',
      Deliver : 'Παράδοση',
      Complete: 'Ολοκλήρωση'
    }
  },

  Status: {
    Canceled: 'Ακυρωμένες | Ακυρωμένη | Ακυρωμένες',
    Delete  : 'Διαγράφηκε'
  },

  SourceType: {
    Title  : 'Πηγή Παραγγελίας',
    Default: {
      ALL: {
        Id   : 0,
        Order: 0,
        Name : 'ALL',
        Title: 'ΟΛΕΣ',
        Desc : 'Όλες οι πηγές παραγγελίας',
        Icon : 'swipe_right_alt'
      },
      ALL_POS: {
        Id   : -1,
        Order: 0,
        Name : 'POS_GROUP',
        Title: 'ΟΛΕΣ ΟΙ POS',
        Desc : 'Όλες οι pos πηγές παραγγελίας',
        Icon : 'shopping_cart'
      },
      ALL_ONLINE: {
        Id   : -2,
        Order: 0,
        Name : 'ONLINE_GROUP',
        Title: 'ΟΛΕΣ ΟΙ ONLINE',
        Desc : 'Όλες οι online πηγές παραγγελίας',
        Icon : 'language'
      },
      ALL_EXTERNAL: {
        Id   : -3,
        Order: 0,
        Name : 'EXTERNAL_GROUP',
        Title: 'ΟΛΕΣ ΟΙ ΕΞΩΤΕΡΙΚΕΣ',
        Desc : 'Όλες οι εξωτερικές πηγές παραγγελίας',
        Icon : 'mdi-store-marker'
      },
      ONLINE: {
        Id   : 1,
        Order: 1,
        Name : 'ONLINE',
        Title: 'WEBSITE',
        Desc : 'Online Παραγγελία - Website',
        Icon : 'language'
      },
      MOBILE: {
        Id   : 10,
        Order: 2,
        Name : 'MOBILE',
        Title: 'MOBILE APP',
        Desc : 'Online Παραγγελία - Mobile App',
        Icon : 'smartphone'
      },
      VOIP: {
        Id   : 2,
        Order: 3,
        Name : 'VOIP',
        Title: 'ΤΗΛΕΦΩΝΟ',
        Desc : 'Τηλεφωνική Παραγγελία',
        Icon : 'phone_in_talk'
      },
      TELEPHONY: {
        Id   : 3,
        Order: 4,
        Name : 'TELEPHONY',
        Title: 'ΤΗΛΕΦΩΝΟ',
        Desc : 'Τηλεφωνική Παραγγελία',
        Icon : 'local_phone'
      },
      TABLE: {
        Id   : 4,
        Order: 5,
        Name : 'TABLE',
        Title: 'ΤΡΑΠΕΖΙ',
        Desc : 'Παραγγελία Τραπεζιού',
        Icon : 'tab_unselected'
      },
      POS: {
        Id   : 5,
        Order: 6,
        Name : 'POS',
        Title: 'POS',
        Desc : 'Εσωτερική Παραγγελία',
        Icon : 'shopping_cart'
      },
      MARKETPLACE: {
        Id   : 11,
        Order: 7,
        Name : 'MARKETPLACE',
        Title: 'MARKETPLACE',
        Desc : 'Παραγγελία Marketplace',
        Icon : 'mdi-store-marker'
      },
      MOBILE_MARKETPLACE: {
        Id   : 12,
        Order: 8,
        Name : 'MOBILE_MARKETPLACE',
        Title: 'MARKETPLACE MOBILE APP',
        Desc : 'Marketplace Παραγγελία - Mobile App',
        Icon : 'mdi-cellphone-link'
      },
      ONLINE_INTERNAL_TABLE: {
        Id   : 6,
        Order: 9,
        Name : 'ONLINE_INTERNAL_TABLE',
        Title: 'ONLINE ΤΡΑΠΕΖΙ',
        Desc : 'Online Παραγγελία - Τραπέζι',
        Icon : 'fas fa-border-none'
      },
      ONLINE_INTERNAL_BOOTH: {
        Id   : 7,
        Order: 10,
        Name : 'ONLINE_INTERNAL_BOOTH',
        Title: 'ONLINE BOOTH',
        Desc : 'Online Παραγγελία - Περίπτερο',
        Icon : 'fas fa-store'
      },
      ONLINE_INTERNAL_ROOM: {
        Id   : 8,
        Order: 11,
        Name : 'ONLINE_INTERNAL_ROOM',
        Title: 'ONLINE ROOM',
        Desc : 'Online Παραγγελία - Δωμάτιο',
        Icon : 'fas fa-h-square'
      },
      ONLINE_INTERNAL_SUNBED: {
        Id   : 9,
        Order: 12,
        Name : 'ONLINE_INTERNAL_SUNBED',
        Title: 'ONLINE SUNBED',
        Desc : 'Online Παραγγελία - Ξαπλώστρα',
        Icon : 'fas fa-umbrella-beach'
      }
    }
  },

  Print: {
    Button: {
      Title: 'Εκτύπωση παραγγελίας',
      Icon : 'print'
    },
    ButtonReportZ: {
      Title: 'ΑΝΑΦΟΡΑ Ζ',
      Icon : 'fa-solid fa-print'
    },
    ButtonReport: {
      Title: 'ΑΝΑΦΟΡΑ',
      Icon : 'fa-solid fa-print'
    },
    Content: {
      DayTotal   : 'Σύνολο Ημέρας',
      Included   : 'Συμπεριλαμβάνονται',
      NotIncluded: 'Δεν Συμπεριλαμβάνονται',
      ByCard     : 'με @:Order.PaymentMethod.Card.Title ('
    },
    Notification       : 'Η παραγγελία στάλθηκε προς εκτύπωση!',
    NotificationReceipt: 'Η απόδειξη στάλθηκε προς εκτύπωση!',
    NotificationTotals : 'Η αναφορά στάλθηκε προς εκτύπωση!'
  },

  OrdersVList: {
    ReOrder: {
      Title   : 'Επαναπαραγγελία',
      All     : 'Όλα',
      Selected: 'Επιλεγμένα',
      Icon    : 'add_shopping_cart'
    }
  },

  OrderWebhookHistoryDialog: {
    Toolbar: {
      Title   : 'Ιστορικό Διαβίβασης',
      Subtitle: 'Παραγγελία',
      Color   : 'info',
      Icon    : 'mdi-webhook'
    },
    Message: {
      Retry: {
        Success: 'Το Retry έχει προγραμματιστεί με επιτυχία',
        Error  : 'Σφάλμα Retry! Το Retry δεν μπορεί να προγραμματιστεί'
      }
    }
  },

  OrderDetailsDialog: {
    Toolbar: {
      Subtitle: 'Στοιχεία Παραγγελίας #'
    },
    Footer: {
      DeliveryCost: 'Χρέωση παράδοσης'
    },
    Customer: {
      Name    : 'ΟΝ/ΜΟ:',
      Phone   : 'ΤΗΛ:',
      Comments: 'ΣΧΟΛΙΑ:',
      Email   : 'EMAIL',
      Address : {
        Title   : 'ΔΙΕΥΘΥΝΣΗ:',
        Street  : 'ΟΔΟΣ:',
        City    : 'ΠΟΛΗ:',
        PostCode: 'Τ.Κ.:',
        Floor   : 'ΟΡΟΦΟΣ:',
        Bell    : 'ΚΟΥΔΟΥΝΙ:',
        Comment : 'ΟΔΗΓΙΕΣ:'
      }
    },
    Notification: {
      Title    : 'Ειδοποιήσεις',
      User     : 'Χρήστης',
      Email    : 'Email',
      Phone    : 'Phone',
      Recipient: 'Παραλήπτης',
      Type     : {
        Title: 'Τύπος',
        Item : {
          status: {
            name : 'Κατάσταση',
            color: 'blue darken-3'
          },
          delivery: {
            name : 'Παραλαβή',
            color: 'purple'
          }
        }
      },
      Via        : 'Μέσω',
      ReadAt     : 'Ανάγνωση',
      OrderStatus: 'Κατάσταση Παραγγελίας',
      DeliveredAt: 'Παράδοση',
      CreatedAt  : 'Αποστολή'
    },
    Transaction: {
      Title      : 'Συναλλαγές',
      History    : 'Ιστορικό',
      Amount     : 'Ποσό',
      PaymentType: 'Τύπος',
      Terminal   : 'EFT/POS',
      Action     : 'Ενέργεια',
      Status     : 'Κατάσταση',
      Date       : 'Ημ/νία',
      CreatedAt  : 'Προσθήκη',
      RemovedAt  : 'Διαγραφή',
      ChangedAt  : 'Αφαίρεση',
      Vendor     : 'Vendor',
      Total      : 'Σύνολο',
      Type       : {
        Sale  : 'Χρέωση',
        Refund: 'Επιστροφή',
        Empty : 'Άγνωστή'
      }
    },
    ReceiptNotify: {
      User       : 'Χρήστης',
      Email      : 'Παραλήπτης',
      CreatedAt  : 'Αποστολή',
      DeliveredAt: 'Παράδοση',
      ReadAt     : 'Ανάγνωση',
      BouncedAt  : 'Bounced'
    },
    Receipt: {
      Title        : 'Παραστατικά',
      Cancel       : 'Ακύρωση Παραστατικού',
      Convert      : 'Μετατροπή σε Τιμολόγιο',
      CancelSuccess: 'Το παραστατικό ακυρώθηκε επιτυχώς',
      ConfirmDialog: {
        Cancel: {
          Title       : 'Ακύρωση Παραστατικού;',
          Content     : 'Είστε σίγουροι ότι θέλετε ακυρώσετε το παραστατικό;',
          Notification: 'Η ακύρωση παραστατικού είναι μη αναστρέψιμη!'
        },
        CancelWithRefund: {
          Title       : 'Ακύρωση Παραστατικού;',
          Content     : 'Είστε σίγουροι ότι θέλετε ακυρώσετε το παραστατικό και να κάνετε επιστροφή {amount} στην κάρτα του πελάτη;',
          Notification: 'Η ακύρωση παραστατικού και η επιστροφή χρημάτων είναι μη αναστρέψιμη!'
        }
      },
      Order      : 'Παραγγελία',
      Type       : 'Τύπος',
      User       : 'Χρήστης',
      DailyCheck : 'Αρ. Ημέρ.',
      OrderNumber: 'Αρ. Παραγ.',
      TotalCheck : 'Αρ. Προόδ.',
      Amount     : 'Πληρ. Ποσό',
      RelatedDocs: 'Σχ. Παραστατ.',
      PrintCount : 'Αρ. Εκτυπώσεων',
      CreatedAt  : 'Ημ/νία',
      Aade       : 'ΑΑΔΕ',
      Status     : 'Κατάσταση',
      Notify     : 'Ειδοποίηση',
      Mark       : 'Μ.Αρ.Κ',
      Uid        : 'Αναγνωριστικό',
      AuthCode   : 'Υπογραφή',
      Provider   : 'Πάροχος',
      Submitted  : 'Το παραστατικό έχει υποβληθεί στην ΑΑΔΕ'
    }
  },

  OrdersAll: {
    Toolbar: {
      Button: {
        Title: 'Νέα παραγγελία',
        Icon : 'add_box'
      }
    },
    Filter: {
      filterOrderType: {
        Type       : 'v-btn-toggle',
        Label      : 'Τύπος Παραγγελίας',
        PlaceHolder: 'Όλοι οι τύποι παραγγελίας',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 0,
            Name : 'Όλες'
          },
          {
            Value: 1,
            Name : 'Παράδοση',
            Icon : 'directions_bike',
            Color: 'purple',
            Class: 'white--text'
          },
          {
            Value: 2,
            Name : 'Παραλαβή',
            Icon : 'directions_run',
            Color: 'blue darken-3',
            Class: 'white--text'
          },
          {
            Value: 3,
            Name : 'Self-Service',
            Icon : 'mdi-gesture-double-tap',
            Color: 'teal',
            Class: 'white--text'
          }
        ]
      },
      filterOrderReceipt: {
        Type       : 'v-btn-toggle',
        Label      : 'Παραστατικό',
        PlaceHolder: 'Όλα',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 0,
            Name : 'Όλα'
          },
          {
            Value: 1,
            Name : 'Ναι',
            Icon : 'mdi-receipt-text-check-outline',
            Color: 'green',
            Class: 'white--text'
          },
          {
            Value: 3,
            Name : 'Ναι > 1',
            Icon : 'mdi-receipt-text-check-outline',
            Color: 'orange',
            Class: 'white--text'
          },
          {
            Value: 2,
            Name : 'Όχι',
            Icon : 'mdi-receipt-text-remove',
            Color: 'red',
            Class: 'white--text'
          }
        ]
      },
      filterWebhookSuccessful: {
        Type       : 'v-btn-toggle',
        Label      : 'Διαβίβαση Παραγγελίας',
        PlaceHolder: 'Όλες',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 0,
            Name : 'Όλες'
          },
          {
            Value: 1,
            Name : 'Επιτυχώς',
            Icon : 'mdi-web-check',
            Color: 'green',
            Class: 'white--text'
          },
          {
            Value: 2,
            Name : 'Ανεπιτυχώς',
            Icon : 'mdi-web-cancel',
            Color: 'red',
            Class: 'white--text'
          }
        ]
      },
      filterIsScheduled: {
        Type       : 'v-btn-toggle',
        Label      : 'Προγραμματισμένη Παραγγελία',
        PlaceHolder: 'Όλες οι παραγγελίες',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 0,
            Name : 'Όλες'
          },
          {
            Value: 1,
            Name : 'Ναι',
            Icon : 'mdi-clock-time-four',
            Color: 'purple',
            Class: 'white--text'
          },
          {
            Value: 2,
            Name : 'Όχι',
            Icon : 'mdi-clock-time-four',
            Color: 'blue darken-3',
            Class: 'white--text'
          }
        ]
      },
      filterHasDeliveryStaff: {
        Type       : 'v-btn-toggle',
        Label      : 'Ανάθεση σε Διανομέα',
        PlaceHolder: 'Όλες οι παραγγελίες',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 0,
            Name : 'Όλες'
          },
          {
            Value: 1,
            Name : 'Ναι',
            Icon : 'directions_bike',
            Color: 'purple',
            Class: 'white--text'
          },
          {
            Value: -1,
            Name : 'Όχι',
            Icon : 'directions_bike',
            Color: 'blue darken-3',
            Class: 'white--text'
          }
        ]
      },
      filterOrderStatus: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : true,
        Label      : 'Κατάσταση Παραγγελίας',
        PlaceHolder: 'Όλες οι καταστάσεις παραγγελίας',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        ItemDesc   : 'Description',
        ItemAll    : {
          Id      : 0,
          StatusId: 0,
          Name    : 'Όλες οι καταστάσεις παραγγελίας',
          Avatar  : {
            Color: 'green',
            Icon : 'mdi-check'
          }
        },
        ItemUnknown: {
          Id      : 0,
          StatusId: 0,
          Name    : 'Unknown',
          Avatar  : {
            Color: 'orange',
            Icon : 'mdi-check'
          }
        },
        Items: [
          {
            Id      : 11,
            StatusId: 11,
            Name    : 'Ληφθείσα',
            Avatar  : {
              Color: 'grey',
              Icon : 'call_received'
            }
          },
          {
            Id      : 12,
            StatusId: 12,
            Name    : 'Αναμονή',
            Avatar  : {
              Color: 'indigo',
              Icon : 'mdi-clock'
            }
          },
          {
            Id      : 21,
            StatusId: 21,
            Name    : 'Αποδεκτή',
            Avatar  : {
              Color: 'green',
              Icon : 'done'
            }
          },
          {
            Id      : 13,
            StatusId: 21,
            Name    : 'Προετοιμάζεται',
            Avatar  : {
              Color: 'purple',
              Icon : 'room_service'
            }
          },
          {
            Id      : 14,
            StatusId: 21,
            Name    : 'Παραδίδεται',
            Avatar  : {
              Color: 'brown',
              Icon : 'directions_run'
            }
          },
          {
            Id      : 15,
            StatusId: 15,
            Name    : 'Ολοκληρωμένη',
            Avatar  : {
              Color: 'light-green',
              Icon : 'done_all'
            }
          },
          {
            Id       : 19,
            StatusId : 19,
            DeletedAt: false,
            Name     : 'Ακυρωμένη',
            Avatar   : {
              Color: 'pink',
              Icon : 'close'
            }
          },
          {
            Id       : -19,
            StatusId : 19,
            DeletedAt: true,
            Name     : 'Διαγραμμένη',
            Avatar   : {
              Color: 'red',
              Icon : 'delete_forever'
            }
          }
        ]
      },
      filterSourceType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Πηγή Παραγγελίας',
        PlaceHolder: 'Όλες οι πηγές παραγγελίας',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        ItemDesc   : 'Description',
        Items      : []
      },
      filterPaymentType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Μέθοδος Πληρωμής',
        PlaceHolder: 'Όλες οι μέθοδοι πληρωμής',
        ItemText   : 'Title',
        ItemValue  : 'Code',
        ItemDesc   : 'Description',
        Items      : []
      },
      filterUser: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Χρήστης',
        PlaceHolder: 'Όλοι οι χρήστες',
        ItemText   : 'Fullname',
        ItemValue  : 'Id',
        Items      : []
      },
      filterStaff: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Χρήστης',
        PlaceHolder: 'Όλοι οι χρήστες',
        ItemText   : 'StaffFullname',
        ItemValue  : 'StaffId',
        Items      : []
      },
      filterPriceFrom: {
        Type       : 'v-text-field',
        Label      : 'Κόστος από',
        PlaceHolder: 'Εισάγετε κόστος από',
        Icon       : 'mdi-currency-eur',
        Cols       : 6
      },
      filterPriceTo: {
        Type       : 'v-text-field',
        Label      : 'Κόστος έως',
        PlaceHolder: 'Εισάγετε κόστος έως',
        Icon       : 'mdi-currency-eur',
        Cols       : 6
      },
      filterDate: {
        Type       : 'v-date-picker',
        Label      : 'Ημερομηνία Παραγγελίας',
        PlaceHolder: 'Επιλέξτε Ημερομηνία',
        Icon       : 'event'
      }
    },
    ListView: {
      Type: {
        Collection: '@:Order.Type.Item.Collection.Title σε',
        Delivery  : '@:Order.Type.Item.Delivery.Title σε'
      },
      WebhookStatus: {
        Success: {
          Name : 'Επιτυχώς',
          Icon : 'mdi-web-check',
          Color: 'success',
          Class: 'white--text'
        },
        Fail: {
          Name : 'Ανεπιτυχώς',
          Icon : 'mdi-web-cancel',
          Color: 'error',
          Class: 'white--text'
        },
        Unknown: {
          Name : 'Άγνωστο',
          Icon : 'mdi-web-off',
          Color: 'blue-grey',
          Class: 'white--text'
        }
      },
      Status: {
        DeletedAt: '@:Order.Status.Delete στις'
      },
      Button: {
        Edit: {
          Title : 'Επεξεργασία παραγγελίας',
          Edited: 'Τροποποιημένη παραγγελία',
          Icon  : 'mdi-text-box-edit-outline',
          Color : 'purple',
          PopUp : {
            Body  : 'Επιλέξτε τρόπο επεξεργασίας της παραγγελίας.',
            Button: {
              Copy   : 'Αντιγραφη & Δημιουργια Νεας',
              Delete : 'Διαγραφη & Δημιουργια Νεας',
              Edit   : 'Ίδιας Παραγγελίας',
              Payment: 'Συναλλαγών / Πληρωμών'
            },
            Notification: ''
          }
        },
        View: {
          Title: 'Προβολή στοιχείων παραγγελίας',
          Icon : 'remove_red_eye',
          Color: 'cyan'
        },
        Convert: {
          Title: 'Μετατροπή σε Τιμολόγιο',
          Icon : 'mdi-file-document-refresh-outline',
          Color: 'orange'
        },
        Cancel: {
          Title: 'Ακύρωση παραγγελίας',
          Icon : 'close',
          Color: 'pink accent-3'
        },
        Revert: {
          Title: 'Επαναφορά κατάστασης σε ολοκληρωμένη',
          Icon : 'undo',
          Color: 'deep-orange'
        },
        Delete: {
          Title: 'Οριστική Διαγραφή Παραγγελίας',
          Icon : 'delete',
          Color: 'red'
        }
      }
    }
  },

  OrderChangeStatusDialog: {
    RevertStatus: {
      Title   : 'Επαναφορά κατάστασης',
      Subtitle: 'Είστε σίγουροι ότι θέλετε να επαναφέρετε την κατάσταση της παραγγελίας "{orderCode}" από ΑΚΥΡΩΜΕΝΗ σε ΟΛΟΚΛΗΡΩΜΕΝΗ;'
    },
    CancelOrder: {
      Title   : '@:Order.OrdersAll.ListView.Button.Cancel.Title;',
      Subtitle: {
        Order            : 'Η παραγγελία',
        CancelPermanently: 'θα ακυρωθεί οριστικά.'
      }
    },
    Field: {
      Name     : '@:Common.Misc.Name:',
      Telephone: 'Τηλέφωνο:',
      Time     : 'Ώρα:',
      Total    : '@:Common.Misc.Total:'
    },
    Notification: {
      Title  : 'Η ακύρωση παραγγελίας είναι μη αναστρέψιμη!',
      Amount : 'Το ποσό των',
      Refund : 'έχει πληρωθεί με κάρτα και θα επιστραφεί αυτόματα.',
      Receipt: 'Για την παραγγελία έχει εκδοθεί απόδειξη και θα ακυρωθεί αυτόματα.',
      Invoice: 'Για την παραγγελία έχει εκδοθεί τιμολόγιο και θα ακυρωθεί αυτόματα.'
    }
  },

  OrderDeleteDialog: {
    DeleteOrder: {
      Title   : 'Οριστική Διαγραφή Παραγγελίας;',
      Subtitle: {
        Order            : 'Η παραγγελία',
        CancelPermanently: 'θα διαγραφεί οριστικά.'
      }
    },
    DeleteOrders: {
      Title   : 'Οριστική Διαγραφή Παραγγελιών;',
      Subtitle: 'Έχετε επιλέξει {orders} παραγγελίες | Έχετε επιλέξει {orders} παραγγελία | Έχετε επιλέξει {orders} παραγγελίες',
      Body    : 'Έχετε επιλέξει {orders} παραγγελίες για οριστική διαγραφή. | Έχετε επιλέξει {orders} παραγγελία για οριστική διαγραφή. | Έχετε επιλέξει {orders} παραγγελίες για οριστική διαγραφή.'
    },
    DeleteAllOrders: {
      Title   : 'Οριστική Διαγραφή Παραγγελιών;',
      Subtitle: '',
      Body    : 'Επιλέξτε αν θέλετε να κάνετε <strong>οριστική διαγραφή όλων</strong> ή <strong>μόνο των δικών</strong> σας παραγγελιών.',
      Button  : {
        YesAll : 'Διαγραφή Όλων',
        YesMine: 'Διαγραφή Δικών μου'
      },
      Notification: {
        Title: 'Η οριστική διαγραφή παραγγελιών είναι μη αναστρέψιμη!'
      }
    },
    Field: {
      Name     : '@:Common.Misc.Name:',
      Telephone: 'Τηλέφωνο:',
      Time     : 'Ώρα:',
      Total    : '@:Common.Misc.Total:'
    },
    Notification: {
      Title                         : 'Η οριστική διαγραφή παραγγελίας είναι μη αναστρέψιμη!',
      Amount                        : 'Το ποσό των',
      RefundNo                      : 'έχει πληρωθεί με κάρτα και <strong>ΔΕΝ ΘΑ ΓΙΝΕΙ ΕΠΙΣΤΡΟΦΗ</strong> αυτόματα.',
      RefundYes                     : 'έχει πληρωθεί με κάρτα και <strong>ΘΑ ΓΙΝΕΙ ΕΠΙΣΤΡΟΦΗ</strong> αυτόματα.',
      ReceiptKeep                   : 'Για την παραγγελία έχει εκδοθεί απόδειξη και <strong>ΔΕΝ ΘΑ ΑΚΥΡΩΘΕΙ</strong> αυτόματα.',
      ReceiptCancel                 : 'Για την παραγγελία έχει εκδοθεί απόδειξη και <strong>ΘΑ ΑΚΥΡΩΘΕΙ</strong> αυτόματα.',
      InvoiceKeep                   : 'Για την παραγγελία έχει εκδοθεί τιμολόγιο και <strong>ΔΕΝ ΘΑ ΑΚΥΡΩΘΕΙ</strong> αυτόματα.',
      InvoiceCancel                 : 'Για την παραγγελία έχει εκδοθεί τιμολόγιο και <strong>ΘΑ ΑΚΥΡΩΘΕΙ</strong> αυτόματα.',
      Tip                           : 'Διαφορετικά κάντε πρώτα "ΑΚΥΡΩΣΗ" και μετά "ΔΙΑΓΡΑΦΗ" παραγγελίας.',
      RefundMultipleNo              : 'Εαν υπάρχουν πληρωμές με κάρτα <strong>ΔΕΝ ΘΑ ΓΙΝΕΙ ΕΠΙΣΤΡΟΦΗ</strong> αυτόματα.',
      RefundMultipleYes             : 'Εαν υπάρχουν πληρωμές με κάρτα <strong>ΘΑ ΓΙΝΕΙ ΕΠΙΣΤΡΟΦΗ</strong> αυτόματα.',
      ReceiptOrInvoiceMultipleKeep  : 'Εάν έχουν εκδοθεί αποδείξεις ή τιμολόγια <strong>ΔΕΝ ΘΑ ΑΚΥΡΩΘΟΥΝ</strong> αυτόματα.',
      ReceiptOrInvoiceMultipleCancel: 'Εάν έχουν εκδοθεί αποδείξεις ή τιμολόγια <strong>ΘΑ ΑΚΥΡΩΘΟΥΝ</strong> αυτόματα.'
    }
  },

  SelectOrderDialog: {
    Toolbar: {
      Title   : 'Παραγγελίες',
      Subtitle: 'Επιλογή Παραγγελίας',
      Icon    : 'shopping_cart',
      Color   : 'indigo'
    },
    Result: {
      Button: {
        All: {
          Title: 'Όλες',
          Icon : 'shopping_cart'
        }
      },
      NoOrder: {
        Title   : 'Δεν Υπάρχουν Παραγγελίες',
        Subtitle: 'ή έχουν προστεθεί όλες σε διανομείς',
        Icon    : 'shopping_cart',
        Color   : 'grey lighten-2'
      }
    }
  },

  OrdersMapDialog: {
    Toolbar: {
      Title   : 'Χάρτης Παραγγελιών',
      Subtitle: 'προς παράδοση',
      Icon    : 'map',
      Color   : 'light-green',
      Button  : {
        ResetMap: {
          Title: 'Επαναφορά Χάρτη',
          Icon : 'my_location'
        },
        MapLimit: {
          Title: 'Όρια Διανομής Καταστήματος',
          Icon : 'map'
        },
        Delivery: {
          Icon: 'directions_bike'
        },
        ReceivedOrder: {
          Title: 'Ληφθείσες Παραγγελίες',
          Icon : 'shopping_cart'
        },
        AcceptedOrder: {
          Title: 'Αποδεκτές Παραγγελίες',
          Icon : 'shopping_cart'
        },
        CompletedOrder: {
          Title: 'Ολοκληρωμένες Παραγγελίες',
          Icon : 'shopping_cart'
        }
      }
    }
  },

  OrdersSaved: {
    ListView: {
      EditedBy : 'Την επεξεργάζεται ο χρήστης',
      BelongsTo: 'Ανήκει στον χρήστη'
    },
    Filter: {
      filterOrderType: {
        Type       : 'v-btn-toggle',
        Label      : 'Τύπος Παραγγελίας',
        PlaceHolder: 'Όλοι οι τύποι παραγγελίας',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 0,
            Name : 'Όλες'
          },
          {
            Value: 1,
            Name : 'Παράδοση',
            Icon : 'directions_bike',
            Color: 'purple',
            Class: 'white--text'
          },
          {
            Value: 2,
            Name : 'Παραλαβή',
            Icon : 'directions_run',
            Color: 'blue darken-3',
            Class: 'white--text'
          },
          {
            Value: 3,
            Name : 'Self-Service',
            Icon : 'mdi-gesture-double-tap',
            Color: 'teal',
            Class: 'white--text'
          }
        ]
      },
      filterOrderWithCompletedCardPayment: {
        Type       : 'v-btn-toggle',
        Label      : 'Κάρτα με Ολοκληρωμένη Πληρωμή',
        PlaceHolder: 'Όλα',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 0,
            Name : 'Όλα'
          },
          {
            Value: 1,
            Name : 'Ναι',
            Icon : 'mdi-receipt-text-check-outline',
            Color: 'green',
            Class: 'white--text'
          },
          {
            Value: 2,
            Name : 'Όχι',
            Icon : 'mdi-receipt-text-remove',
            Color: 'red',
            Class: 'white--text'
          }
        ]
      },
      filterSourceType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Πηγή Παραγγελίας',
        PlaceHolder: 'Όλες οι πηγές παραγγελίας',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        ItemDesc   : 'Description',
        Items      : []
      },
      filterPaymentType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Μέθοδος Πληρωμής',
        PlaceHolder: 'Όλες οι μέθοδοι πληρωμής',
        ItemText   : 'Title',
        ItemValue  : 'Code',
        ItemDesc   : 'Description',
        Items      : []
      }
    }
  },

  OrdersToday: {
    Toolbar: {
      Button: {
        Print: {
          Title       : 'Εκτύπωση',
          Icon        : 'print',
          Notification: 'Οι παραγγελίες στάλθηκαν προς εκτύπωση!'
        },
        Map: {
          Title: 'Χάρτης',
          Icon : 'map'
        },
        All: {
          Title: 'Όλες',
          Icon : 'shopping_cart'
        }
      }
    },
    Filter: {
      filterOrderType: {
        Type       : 'v-btn-toggle',
        Label      : 'Τύπος Παραγγελίας',
        PlaceHolder: 'Όλοι οι τύποι παραγγελίας',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 0,
            Name : 'Όλες'
          },
          {
            Value: 1,
            Name : 'Παράδοση',
            Icon : 'directions_bike',
            Color: 'purple',
            Class: 'white--text'
          },
          {
            Value: 2,
            Name : 'Παραλαβή',
            Icon : 'directions_run',
            Color: 'blue darken-3',
            Class: 'white--text'
          },
          {
            Value: 3,
            Name : 'Self-Service',
            Icon : 'mdi-gesture-double-tap',
            Color: 'teal',
            Class: 'white--text'
          }
        ]
      },
      filterOrderReceipt: {
        Type       : 'v-btn-toggle',
        Label      : 'Παραστατικό',
        PlaceHolder: 'Όλα',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 0,
            Name : 'Όλα'
          },
          {
            Value: 1,
            Name : 'Ναι',
            Icon : 'mdi-receipt-text-check-outline',
            Color: 'green',
            Class: 'white--text'
          },
          {
            Value: 3,
            Name : 'Ναι > 1',
            Icon : 'mdi-receipt-text-check-outline',
            Color: 'orange',
            Class: 'white--text'
          },
          {
            Value: 2,
            Name : 'Όχι',
            Icon : 'mdi-receipt-text-remove',
            Color: 'red',
            Class: 'white--text'
          }
        ]
      },
      filterOrderNoCardPayment: {
        Type       : 'v-btn-toggle',
        Label      : 'Κάρτα με Ολοκληρωμένη Πληρωμή',
        PlaceHolder: 'Όλα',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 0,
            Name : 'Όλα'
          },
          {
            Value: 1,
            Name : 'Ναι',
            Icon : 'mdi-receipt-text-check-outline',
            Color: 'green',
            Class: 'white--text'
          },
          {
            Value: 2,
            Name : 'Όχι',
            Icon : 'mdi-receipt-text-remove',
            Color: 'red',
            Class: 'white--text'
          }
        ]
      },
      filterWebhookSuccessful: {
        Type       : 'v-btn-toggle',
        Label      : 'Διαβίβαση Παραγγελίας',
        PlaceHolder: 'Όλες',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 0,
            Name : 'Όλες'
          },
          {
            Value: 1,
            Name : 'Επιτυχώς',
            Icon : 'mdi-web-check',
            Color: 'green',
            Class: 'white--text'
          },
          {
            Value: 2,
            Name : 'Ανεπιτυχώς',
            Icon : 'mdi-web-cancel',
            Color: 'red',
            Class: 'white--text'
          }
        ]
      },
      filterIsScheduled: {
        Type       : 'v-btn-toggle',
        Label      : 'Προγραμματισμένη Παραγγελία',
        PlaceHolder: 'Όλες οι παραγγελίες',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 0,
            Name : 'Όλες'
          },
          {
            Value: 1,
            Name : 'Ναι',
            Icon : 'mdi-clock-time-four',
            Color: 'purple',
            Class: 'white--text'
          },
          {
            Value: 2,
            Name : 'Όχι',
            Icon : 'mdi-clock-time-four',
            Color: 'blue darken-3',
            Class: 'white--text'
          }
        ]
      },
      filterHasDeliveryStaff: {
        Type       : 'v-btn-toggle',
        Label      : 'Ανάθεση σε Διανομέα',
        PlaceHolder: 'Όλες οι παραγγελίες',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 0,
            Name : 'Όλες'
          },
          {
            Value: 1,
            Name : 'Ναι',
            Icon : 'directions_bike',
            Color: 'purple',
            Class: 'white--text'
          },
          {
            Value: -1,
            Name : 'Όχι',
            Icon : 'directions_bike',
            Color: 'blue darken-3',
            Class: 'white--text'
          }
        ]
      },
      filterOrderStatus: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : true,
        Label      : 'Κατάσταση Παραγγελίας',
        PlaceHolder: 'Όλες οι καταστάσεις παραγγελίας',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        ItemDesc   : 'Description',
        ItemAll    : {
          Id      : 0,
          StatusId: 0,
          Name    : 'Όλες οι καταστάσεις παραγγελίας',
          Avatar  : {
            Color: 'green',
            Icon : 'mdi-check'
          }
        },
        ItemUnknown: {
          Id      : 0,
          StatusId: 0,
          Name    : 'Unknown',
          Avatar  : {
            Color: 'orange',
            Icon : 'mdi-check'
          }
        },
        Items: [
          {
            Id      : 11,
            StatusId: 11,
            Name    : 'Ληφθείσα',
            Avatar  : {
              Color: 'grey',
              Icon : 'call_received'
            }
          },
          {
            Id      : 12,
            StatusId: 12,
            Name    : 'Αναμονή',
            Avatar  : {
              Color: 'indigo',
              Icon : 'mdi-clock'
            }
          },
          {
            Id      : 21,
            StatusId: 21,
            Name    : 'Αποδεκτή',
            Avatar  : {
              Color: 'green',
              Icon : 'done'
            }
          },
          {
            Id      : 13,
            StatusId: 21,
            Name    : 'Προετοιμάζεται',
            Avatar  : {
              Color: 'purple',
              Icon : 'room_service'
            }
          },
          {
            Id      : 14,
            StatusId: 21,
            Name    : 'Παραδίδεται',
            Avatar  : {
              Color: 'brown',
              Icon : 'directions_run'
            }
          },
          {
            Id      : 15,
            StatusId: 15,
            Name    : 'Ολοκληρωμένη',
            Avatar  : {
              Color: 'light-green',
              Icon : 'done_all'
            }
          },
          {
            Id       : 19,
            StatusId : 19,
            DeletedAt: false,
            Name     : 'Ακυρωμένη',
            Avatar   : {
              Color: 'pink',
              Icon : 'close'
            }
          },
          {
            Id       : -19,
            StatusId : 19,
            DeletedAt: true,
            Name     : 'Διαγραμμένη',
            Avatar   : {
              Color: 'red',
              Icon : 'delete_forever'
            }
          }
        ]
      },
      filterSourceType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Πηγή Παραγγελίας',
        PlaceHolder: 'Όλες οι πηγές παραγγελίας',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        ItemDesc   : 'Description',
        Items      : []
      },
      filterPaymentType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Μέθοδος Πληρωμής',
        PlaceHolder: 'Όλες οι μέθοδοι πληρωμής',
        ItemText   : 'Title',
        ItemValue  : 'Code',
        ItemDesc   : 'Description',
        Items      : []
      },
      filterUser: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Χρήστης',
        PlaceHolder: 'Όλοι οι χρήστες',
        ItemText   : 'Fullname',
        ItemValue  : 'Id',
        Items      : []
      },
      filterStaff: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Χρήστης',
        PlaceHolder: 'Όλοι οι χρήστες',
        ItemText   : 'StaffFullname',
        ItemValue  : 'StaffId',
        Items      : []
      },
      filterPriceFrom: {
        Type       : 'v-text-field',
        Label      : 'Κόστος από',
        PlaceHolder: 'Εισάγετε κόστος από',
        Icon       : 'mdi-currency-eur',
        Cols       : 6
      },
      filterPriceTo: {
        Type       : 'v-text-field',
        Label      : 'Κόστος έως',
        PlaceHolder: 'Εισάγετε κόστος έως',
        Icon       : 'mdi-currency-eur',
        Cols       : 6
      },
      filterDate: {
        Type       : 'v-date-picker',
        Label      : 'Ημερομηνία Παραγγελίας',
        PlaceHolder: 'Επιλέξτε Ημερομηνία',
        Icon       : 'event'
      }
    },
    ListView: {
      Button: {
        OrderPayment: {
          Title: 'Συναλλαγές Πληρωμών',
          Icon : 'mdi-account-credit-card',
          Color: 'indigo'
        },
        AddTo: {
          Title: 'Προσθήκη παραγγελίας σε βάρδια διανομέα',
          Icon : 'directions_bike',
          Color: 'light-green darken-1'
        },
        RemoveFrom: {
          Title: 'Αφαίρεση παραγγελίας από βάρδια διανομέα',
          Icon : 'directions_bike',
          Color: 'red accent-4',
          PopUp: {
            Title  : 'Αφαίρεση Παραγγελίας;',
            Content: 'Είστε σίγουροι ότι θέλετε να αφαιρέσετε την παραγγελία από τη βάρδια του διανομέα:'
          }
        }
      }
    }
  },

  OrdersToolbar: {
    All      : 'Όλες',
    Today    : 'Σημερινές',
    Scheduled: 'Προγραμματισμένες',
    Saved    : 'Αποθηκευμένες'
  },

  PrintNotifyType: {
    ORDER: {
      Title: 'ΠΑΡΑΓΓΕΛΙΑ',
      Color: 'light-blue'
    },
    PREPARATION: {
      Title: 'ΠΡΟΕΤΟΙΜΑΣΙΑ',
      Color: 'brown'
    },
    RECEIPT: {
      Title: 'ΠΑΡΑΣΤΑΤΙΚΟ',
      Color: 'light-green'
    },
    RECEIPT_CREDIT: {
      Title: 'ΠΙΣΤΩΤΙΚΟ',
      Color: 'red'
    },
    FNB: {
      Title: 'ΔΕΛΤΙΟ ΠΑΡΑΓΓΕΛΙΑΣ',
      Color: 'blue-grey'
    },
    FNB_CANCEL: {
      Title: 'ΔΕΛΤΙΟ ΑΚΥΡΩΣΗΣ',
      Color: 'red'
    },
    FNB_RETURN: {
      Title: 'ΔΕΛΤΙΟ ΕΠΙΣΤΡΟΦΗΣ',
      Color: 'orange'
    },
    UNKNOWN: {
      Title: 'ΑΓΝΩΣΤΟ',
      Color: 'grey'
    },
    TABLE_ORDER_ITEMS_CANCELED: {
      Title: 'ΑΚΥΡ. ΠΡΟΪΟΝΤ.',
      Color: 'red'
    }
  }
}
